import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuthStore } from '../store/authStore';
import Brand from '../components/Brand';
import { CheckCircle, Lock, ShoppingBag, Sparkles } from 'lucide-react';

export default function PurchasePage() {
  const { user, refreshMe } = useAuthStore();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const nav = useNavigate();

  const purchase = async () => {
    setBusy(true); setErr(null);
    try {
      await api.post('/api/purchase', {
        shipping_name: user?.name || 'Reader',
        shipping_address: '123 Embrace Way',
        shipping_city: 'NYC',
        shipping_state: 'NY',
        shipping_zip: '10001',
        shipping_country: 'USA',
      });
      await refreshMe();
      nav('/dashboard');
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ee-bg">
      <div className="p-6"><Brand /></div>
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Unlock Everything</div>
          <h1 className="hero-title text-4xl md:text-5xl text-white">The Complete Embrace</h1>
          <p className="text-ee-text2 mt-3">One purchase. Hardcover, e-book, and unlimited EE access.</p>
        </div>
        <div className="ee-card p-10 relative" style={{ boxShadow: '0 0 60px -20px rgba(196,161,68,0.35)' }}>
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 px-4 py-1 rounded-b gold-grad text-black text-xs font-semibold tracking-widest uppercase">Best Value</div>
          <div className="text-center pt-4 pb-6 border-b border-ee-border">
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-6xl text-gold font-serif">$49</span>
              <span className="text-ee-muted">one-time</span>
            </div>
          </div>
          <ul className="py-8 space-y-3">
            {['Hardcover book shipped to your door','Full e-book in your reader','Unlimited conversations with EE','Lifetime updates to the philosophy','30-day satisfaction guarantee'].map((t) => (
              <li key={t} className="flex items-start gap-3 text-ee-text2"><CheckCircle size={18} className="text-gold flex-shrink-0 mt-0.5" /> {t}</li>
            ))}
          </ul>
          {err && <div className="mb-4 text-sm text-red-400 bg-red-400/10 border border-red-400/30 rounded-md p-2">{err}</div>}
          <button data-testid="purchase-btn" onClick={purchase} disabled={busy} className="w-full inline-flex items-center justify-center gap-2 py-4 rounded-md gold-grad text-black font-semibold shadow-lg shadow-gold/20 disabled:opacity-50 hover:-translate-y-0.5 transition-all">
            <ShoppingBag size={18} /> {busy ? 'Processing…' : 'Complete Purchase — $49'}
          </button>
          <div className="text-center text-xs text-ee-muted mt-4 flex items-center justify-center gap-1"><Lock size={12} /> Secure mock checkout</div>
        </div>
      </div>
    </div>
  );
}
